import {BaseService} from "@/core/services/BaseService";

class ProviderService extends BaseService<any> {
  endpoint = "/provider"

  async complete(id) {
    return await this.http().patch(this.endpoint + "/" + id + "/complete").then(res => {
      return res.data
    })
  }
}

export default new ProviderService();